export default class Scheduler {
  constructor (store) {
    this.store = store
  }

  run () {
    const due = this.store.getters['jobs/all'].filter((job) => job.isDue() && !job.isRunning())
    if (due.length === 0) {
      return
    }
    for (const i in due) {
      const job = due[i]
      try {
        this.store.commit('jobs/MARK_AS_RUNNING', job)
        this.store.dispatch(`${job.store}/${job.action}`, {'source': 'scheduler'})
        this.store.commit('jobs/MARK_AS_RUN', job)
      } catch (e) {
        this.store.commit('jobs/MARK_AS_FAILED', job)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/scheduler.js